import { EntityType } from '@frontend/common';
import { NotificationTemplateClient } from '@frontend/notification/api';
import { NotificationTemplate, UpdateNotificationTemplate } from '@frontend/notification/types';
import { FormattedMessage } from 'react-intl';

import UpdateModal from '../../../../modal/update-modal/update-modal.component';
import { useUpdateTemplateModal } from './update-template-modal.controller';

export interface UpdateTemplateModalProps {
    template: NotificationTemplate;
    callBack?: (value: NotificationTemplate) => void;
}

export const UpdateTemplateModal = (props: UpdateTemplateModalProps) => {
    const viewProps = useUpdateTemplateModal(props);

    return (
        <UpdateModal<NotificationTemplate, UpdateNotificationTemplate>
            order={['name', 'description']}
            object={props.template}
            onSubmit={(v) => NotificationTemplateClient.patchNotificationTemplate(props.template.account_id, props.template.id, v)}
            type={EntityType.NOTIFICATION_TEMPLATE}
            values={viewProps.formValues}
            expectedType={new Map([['description', 'textarea']])}
            onSubmitSuccess={(v) => props.callBack && props.callBack(v)}
            formId={viewProps.templateFormId}
            label={
                <FormattedMessage
                    id='update-template.label'
                    defaultMessage='Update notification template'
                />
            }
        />
    );
};
